import { render, staticRenderFns } from "./TherapistListItem.vue?vue&type=template&id=0dd5c786&scoped=true"
import script from "./TherapistListItem.vue?vue&type=script&lang=js"
export * from "./TherapistListItem.vue?vue&type=script&lang=js"
import style0 from "./TherapistListItem.vue?vue&type=style&index=0&id=0dd5c786&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd5c786",
  null
  
)

export default component.exports